<template>
	<transition name="fade">
		<div id="home">
			<!-- <h2>Minha área exclusiva</h2> -->
			<!-- <header>
				<box-header-home icon="fas fa-cubes" title="objetos cadastrados" :quantity="quantitativos.totalDeObjetos" link="/" />
				<box-header-home icon="fas fa-user" title="acessos" :quantity="quantitativos.totalDeAcessos" link="/" />
				<box-header-home icon="fas fa-download" title="downloads" :quantity="quantitativos.totalDeDownloads" link="/" />
			</header> -->
			<section class="create-objects">
				<!--<p>Você já cadastrou <strong>{{quantitativoMeusObjetosCadastrados}} objetos</strong> no mês</p>
				<router-link to="/objetos/create" tag="button">NOVO OBJETO</router-link>-->
				<p> </p>
				<router-link v-if="this.$auth.user().perfil !== 6" to="/objetos/create" tag="button">NOVO OBJETO</router-link>
			</section>

			<section class="graphs-objects">
				<div class="created-monthly" v-if="chartData.length > 0">
					<p class="title-graph">Quantidade de objetos cadastrados por mês</p>
					<div class="anos-selecionar">
						Selecione o ano:
						<div class="multiselect-container">
							<multiselect v-model="anoSelecionado" @select="fitrarPorAno" :options="anos" :close-on-select="true" placeholder="Selecione o ano"
								:searchable="true" :showNoResults="true" selectedLabel="Selecionado" selectLabel="" deselectLabel="" :allow-empty="false"
								label="ano" track-by="ano">
							</multiselect>
						</div>
					</div>
					<GChart
						type="ColumnChart"
						:data="chartData"
					/>
				</div>

				<!--<div class="object-by-topics">
					<div class="title">
						<p class="name-obj">Objeto: </p>
						<multiselect v-model="tipoSelecionado" @select="filtrarPorTipo" :options="objetosCadastradosPorTipo" :close-on-select="true" placeholder="Selecione o tipo"
								:searchable="true" :showNoResults="true" selectedLabel="Selecionado" selectLabel="" deselectLabel="" :allow-empty="false"
								label="tipo" track-by="tipo">
						</multiselect>
					</div>
					<div class="field">
						<div class="logo"><i class="fas fa-cubes"></i></div>
						<div class="quantity">{{conteudoTipoSelecionado.objetos}}</div>
						<div class="description">CADASTRADOS</div>
					</div>

					<div class="field">
						<div class="logo"><i class="fas fa-download"></i></div>
						<div class="quantity">{{conteudoTipoSelecionado.quantidadeDownloads}}</div>
						<div class="description">DOWNLOADS</div>
					</div>-->

					<!-- <div class="field">
						<div class="logo"><i class="fas fa-heart"></i></div>
						<div class="quantity">{{conteudoTipoSelecionado.quantidadeCurtidas}}</div>
						<div class="description">CURTIDAS</div>
					</div>
				</div> -->
			</section>

			<section class="created-objects-porcentage">
				<!--<h3><span></span>Percentual de objetos cadastrados no repositório</h3>
				<div class="items">
					<div class="item" v-for="item in objetosCadastradosPorTipo" :key="item.tipo">
						<div class="quantity">{{ parseFloat((item.objetos / totalDeObjetos) * 100).toFixed(2) }}%</div>
						<div class="description">{{item.tipo}}</div>
						<img src="@/assets/img/trends_arrow_up.svg" alt="">
					</div> -->

					<!-- <div class="item">
						<div class="quantity">100%</div>
						<div class="description">Imagens</div>
						<img src="@/assets/img/trends_arrow_up.svg" alt="">
					</div>
					-->
				<!--</div>-->
			</section>

			<!-- <div class="performance-by-user">
				<h3><span></span>Desempenho por usuário</h3>

				<div class="table">
					<table>
						<thead>
							<tr>
								<th>Usuário</th>
								<th>Objetos</th>
								<th>Data do último</th>
								<th>Downloads</th>
								<th>Curtidas</th>
								<th></th>
							</tr>
						</thead>

						<tbody>
							<tr>
								<td>Felipe Ferreira Barros</td>
								<td>43</td>
								<td>26/08/2019</td>
								<td>100.000</td>
								<td>100.000</td>
								<td><router-link to="/">DETALHAR</router-link></td>
							</tr>
						</tbody>
					</table>
				</div>

			</div> -->

		</div>

	</transition>
</template>

<script>

// import BoxHeaderHome from '@/components/views/home/inc/BoxHeaderHome'
import { GChart } from 'vue-google-charts'
import { dashboard } from '@/services/dashboard'
export default {
	name: 'Home',
	title: 'Dashboard',
	components: {
		// BoxHeaderHome,
		GChart,
		// eslint-disable-next-line vue/no-unused-components
		console: () => console
	},
	data () {
		return {
			chartData: [
				// ['Teste', 'teste', { role: 'style' }, { role: 'annotation' }]
				// ['Jan', 630, 'color: #e5e4e2', ''],
				// ['Fev', 467, 'color: #e5e4e2', ''],
				// ['Mar', 854, 'color: #e5e4e2', ''],
				// ['Abr', 345, 'color: #e5e4e2', ''],
				// ['Mai', 510, 'color: #e5e4e2', ''],
				// ['Jun', 256, 'color: #e5e4e2', ''],
				// ['Jul', 712, 'color: #f5667d', ''],
				// ['Ago', 800, 'color: #e5e4e2', ''],
				// ['Set', 89, 'color: #e5e4e2', ''],
				// ['Out', 123, 'color: #e5e4e2', ''],
				// ['Nov', 411, 'color: #e5e4e2', ''],
				// ['Dez', 300, 'color: #565656', '']
			],
			// chartOptions: {
			// 	chart: {
			// 		title: 'Company Performance',
			// 		subtitle: 'te,fds ,g'
			// 	},
			// 	width: '100%'
			// },

			anoSelecionado: { ano: new Date().getFullYear() },
			tipoSelecionado: {},
			conteudoTipoSelecionado: {},
			anos: [],
			totalDeObjetos: 0,
			quantitativos: 0,
			quantitativoMeusObjetosCadastrados: 0,
			objetosCadastradosPorTipo: [],
			objetosCadastradosPorMes: [],
			test: ''
		}
	},
	async created () {
		// const anoInicial = 2016
		// const anoFim = new Date().getFullYear()
		// console.log('fasfd', this.anoSelecionado)
		// const diferenca = anoFim - anoInicial
		// for (let i = 0; i <= diferenca; i++) {
		// 	this.anos.push({ ano: anoInicial + i })
		// }
		// await dashboard.find(this.anoSelecionado.ano)
		// 	.then(resultado => {
		// 		this.quantitativos = resultado.data.quantitativos[0]
		// 		this.quantitativoMeusObjetosCadastrados = resultado.data.quantitativoMeusObjetosCadastrados
		// 		this.chartData = resultado.data.objetosCadastradosPorMes
		// 		this.objetosCadastradosPorTipo = resultado.data.objetosCadastradosPorTipo
		// 		this.tipoSelecionado = { tipo: resultado.data.objetosCadastradosPorTipo[0].tipo }
		// 		this.totalDeObjetos = resultado.data.objetosCadastradosPorTipo.reduce((acc, dado) => { return acc + dado.objetos }, 0)
		// 		this.conteudoTipoSelecionado = resultado.data.objetosCadastradosPorTipo[0]
		// 	})
	},
	methods: {
		fitrarPorAno () {
			setTimeout(async () => {
				const retorno = await dashboard.findMoth(this.anoSelecionado.ano)
				this.chartData = retorno.data.objetosCadastradosPorMes
			}, 200)
		},
		filtrarPorTipo () {
			setTimeout(() => {
				this.conteudoTipoSelecionado = this.objetosCadastradosPorTipo.find(nome => nome.tipo === this.tipoSelecionado.tipo)
			}, 200)
		}
	}
}
</script>

<style lang="scss" scoped>
#home {
	margin-top: 100px;

	header {
		display: grid;
		grid-template-columns: auto auto auto;
		grid-gap: 10px 30px;
	}

	h2 {
		font-size: 1.5em;
		color: #fff;
		font-weight: $font-weight-default-bolder;
		position: absolute;
		margin-top: 10px;
	}

	.create-objects {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 28px 0 230px;
		background-color: #1E5C9F;
		background-image: url("./../../../assets/img/obj.png");
		background-repeat: no-repeat;
		width: 100%;
		height: 96px;
		border-radius: 5px;

		p {
			font-size: 1.500em;
			color: #fff;

			strong {
				font-weight: $font-weight-default-bolder;
				color: #E2E41A;
			}
		}

		button {
			width: 240px;
			height: 40px;
			border: none;
			border-radius: 5px;
			outline: none;
			background-color: #E2E41A;
			color: #1B2838;
			font-size: 1em;
			font-weight: $font-weight-default-bolder;
			cursor: pointer;
		}
	}

	.graphs-objects {
		display: flex;
		justify-content: space-between;
		margin-top: 60px;
		width: 100%;

		.created-monthly {
			width: calc(100% - 300px);
			background-color: #fff;
			margin-right: 10px;
			color: #000;
			border-radius: 5px;

			.title-graph {
				display:flex;
				justify-content: center;
				padding: 20px 0px;
			}

			div {
				width: 100%;

				&.anos-selecionar {
					display: flex;
					align-items: center;
					width: unset;
					margin: 10px 30px;

					.multiselect-container {
						display: inline-flex;
						align-items: center;
						width: 90px;
						margin-left: 10px;
						background-color: #EBF0F9;

						.multiselect {
							display: flex;
							align-items: center;
							color: #333;
						}
					}
				}
			}
		}

		.object-by-topics {
			width: 300px;
			background-color: #1B2838;
			padding: 20px;
			border-radius: 5px;

			.title {
				display: flex;
				color: #fff;
				font-weight: $font-weight-default-bolder;
				border-bottom: 1px solid #d4d7db;
				align-content: center;
				.multiselect {
					display: inline-flex;
					width:unset;
					.multiselect__tags {
							color: #000 !important;
						.multiselect__single {
							color: #fff !important;
						}
					}
				}
				.name-obj {
					display:inline-flex;
					margin-top: 5px;
				}
			}

			.field {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding-top: 30px;

				.logo {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 60px;
					height: 60px;
					border-radius: 100px;
					background: #d4d7db;
					font-size: 2em;
					color:#1b2838;
				}

				.quantity {
					color: #d4d7db;
					font-size: 1.8em;
					font-weight: $font-weight-default-bolder;
				}

				.description {
					font-size: .8em;
					color: #a4a4a4;
				}
			}
		}

		.created-monthly, .object-by-topics {
			height: 350px;
		}
	}

	.created-objects-porcentage {

		.items {
			display: grid;
			grid-template-columns: auto auto auto auto;
			grid-gap: 10px 10px;
			margin-top: 30px;

			.item {
				display: flex;
				justify-content: space-between;
				background-color: #fff;
				padding: 10px;
				border-radius: 15px;
				color: #1a2738;

				.quantity {
					font-size: 1.2em;
					font-weight: $font-weight-default-bolder;
					background-color: #013556;
					border-radius: 12px;
					width: 70px;
					height: 50px;
					color:#fff;
					text-align: center;
					align-items: center;
					justify-content: center;
					display: flex;
				}

				.description {
					font-size: 1em;
					font-weight: $font-weight-default-bolder;
					text-align: center;
					align-items: center;
					justify-content: center;
					display: flex;
				}

				img {
					font-size: 3em;

				}
			}
		}
	}

	.performance-by-user, .created-objects-porcentage {
		margin-top: 100px;

		h3 {
			display: flex;
			align-items: center;
			color: #1e5c9f;
			font-weight: $font-weight-default-bolder;
			text-transform: uppercase;
			span {
				display: block;
				background-color: #1e5c9f;
				width: 65px;
				height: 30px;
				border-radius: 20px;
				margin-left: 10px;
				margin-right: 20px;
			}
		}
	}
}
</style>

<style lang="scss">
	.created-monthly div.anos-selecionar .multiselect-container  .multiselect {
		.multiselect__tags {
			display: flex;
			align-items: center;
			padding: 0 10px !important;

			.multiselect__single {
				padding: 0 !important;
				margin: 0;
			}
		}
	}
</style>
